import { Component, ElementRef, EventEmitter, Injector, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { filter, includes, isEmpty, uniqueId } from 'lodash';

import { BaseComponent } from '../../base.component';

@Component({
	selector: 'round-image',
	encapsulation: ViewEncapsulation.None,
	template: `
		<span
			class="focus-container"
			tabindex="0"
			(keypress)="$event.key == 'Enter' ? onToggle({ value: option.value }) : false"
		>
			<label
				class="{{ setClass() }}"
				tabindex="-1"
				[attr.id]="control.name.split('PolicyData.').join('')"
				[attr.aria-describedby]="parentName.split('.').join('_') + '_error'"
				(keydown)="toggle($event)"
				(click)="onToggle({ value: option.value })"
				[ngClass]="{ selected: isSelected }"
				aria-live="polite"
				aria-relevant="text"
				(focus)="setTitle()"
				(blur)="removeTitle()"
				[attr.aria-label]="option.title"
			>
				<div class="image"></div>
				<div class="label" [attr.aria-label]="option.title">{{ option.title }}</div>
			</label>
		</span>
	`,
	styleUrls: ['./round-image.component.scss'],
})
export class RoundImageComponent extends BaseComponent implements OnInit {
	@Input() isSelected: boolean;
	@Input() option: any;
	@Input() ngClass: any;
	@Input() control: control;
	@Input() context: any;
	@Input() value: any;
	@Input() setAnswer: any;
	@Input() parentName: any;

	@Output() ToggleRoundImage: EventEmitter<any> = new EventEmitter();

	mode: any;
	isOpen: boolean;
	radio: any;
	multi: any;
	uId: any;
	name: any;

	constructor(injector: Injector, private el: ElementRef) {
		super(injector);
		this.radio = 'radio';
		this.multi = 'multi';
		this.uId = uniqueId();
	}

	ngOnInit() {
		const imageElem = this.el.nativeElement.querySelectorAll('.image')[0];

		imageElem.style.backgroundImage = `url('${this.option.image}')`;

		this.mode = this.getMode();
	}

	ngAfterContentInit() {
		this.name = this.control ? this.control.name + 'child' : '';
		this.name = this.control ? this.name + this.uId : '';
	}

	getMode() {
		return this.control.attributes.maxLength === 1 ? this.radio : this.multi;
	}

	toggle(event) {
		//key code '32' means 'Space' key

		if (event.keyCode === 32) {
			this.onToggle({ value: this.option.value });

			event.preventDefault();
			event.stopPropagation();
			event.stopImmediatePropagation();
		}
	}

	onToggle(value) {
		this.ToggleRoundImage.emit();
		this.elementRef.nativeElement.children[0].title = 'selected';
		this.splunkAnalyticsService.publish(
			'ButtonClick',
			this.control.title,
			this.control.options.filter((o) => o.value == value.value)[0].title
		);
	}

	setClass() {
		return `round-image-container ${this.control.attributes ? this.control.attributes.class : ''}`;
	}

	setTitle() {
		var titleForNotSelected = this.control.title;
		var titleForSelected = this.control.title + ' selected';

		var nativeElement = this.elementRef.nativeElement;
		var nativeElementChild = nativeElement.querySelector('label');

		if (
			nativeElement.attributes['ng-reflect-is-selected'] &&
			nativeElement.attributes['ng-reflect-is-selected'].value &&
			nativeElementChild.className.includes('selected')
		) {
			this.elementRef.nativeElement.querySelector('label').title = titleForSelected;
		} else {
			this.elementRef.nativeElement.querySelector('label').title = titleForNotSelected;
		}
	}

	removeTitle() {
		this.elementRef.nativeElement.querySelector('label').title = '';
	}
}
